import { z } from 'zod';

export type CategoryId = number;

/** Manzanita.Web.Features.Catalog.Categories.ProductCategoryModel */
export interface Category {
	description: string;
	categoryId: CategoryId;
	categoryCode: string;
	categoryImageUrl: string | null;
	hasProducts: boolean;
}

export interface CategoryListingFilters
	extends Partial<Omit<Category, 'categoryId' | 'categoryCode' | 'categoryImageUrl'>> {}

export type SaveCategoryRequest = z.infer<typeof saveCategoryRequestSchema>;

/** Manzanita.Web.Features.Catalog.Categories.ProductCategoriesController.ProductCategoryDeleteModel  */
export type DeleteCategoryRequest = z.infer<typeof deleteCategoryRequestSchema>;

export const categoryIdSchema = z.number();

/** Manzanita.Web.Features.Catalog.Categories.ProductCategoryModel */
export const categorySchema = z.object({
	categoryId: categoryIdSchema,
	description: z.string(),
	categoryCode: z.string(),
	categoryImageUrl: z.string().nullable(),
	hasProducts: z.boolean(),
}) satisfies z.ZodType<Category>;

export const categoryListingFiltersSchema = categorySchema.partial().omit({
	categoryId: true,
	categoryCode: true,
	categoryImageUrl: true,
}) satisfies z.ZodType<CategoryListingFilters>;

/** Manzanita.Web.Features.Catalog.Categories.ProductCategoriesController.ProductCategoryDeleteModel  */
export const deleteCategoryRequestSchema = z.object({
	idList: categoryIdSchema.array(),
});

export const saveCategoryRequestSchema = categorySchema.omit({ hasProducts: true }).extend({
	categoryId: categoryIdSchema.optional(),
	categoryCode: z.string().min(1),
	description: z.string().min(1),
});
